import { IAppSettings } from "../../models/settings";
export const SettingsState: IAppSettings = {
  countryCodes: [],
};
